import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";
import { PresetDeleteDialogProps } from "@/pages/Chat/components/ModalGenerationSettings/PresetsManager/types";

export function PresetDeleteDialog({ presetName, onConfirm, onCancel, isDisabled, isDeleting }: PresetDeleteDialogProps) {
  return (
    <div className="flex flex-col p-3 border border-gray-6 rounded-md bg-gray-2 dark:bg-gray-5 gap-2">
      <Text variant={TextVariants.LABEL_MEDIUM_MEDIUM} className="text-gray-12">
        <Trans i18nKey="chat:modal.generationSettings.presets.deleteConfirm" values={{ presetName }} />
      </Text>
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11">
        <Trans i18nKey="chat:modal.generationSettings.presets.deleteCannotUndo" />
      </Text>
      <div className="flex flex-row gap-2">
        <Button size={ButtonSize.SMALL} variant={ButtonVariant.OUTLINED} onClick={onCancel} disabled={isDisabled || isDeleting}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button size={ButtonSize.SMALL} onClick={onConfirm} disabled={isDisabled || isDeleting} className="bg-red-9 text-white hover:bg-red-10">
          {isDeleting ? <Trans i18nKey="chat:modal.generationSettings.presets.deleting" /> : <Trans i18nKey="common:delete" />}
        </Button>
      </div>
    </div>
  );
}
